// src/components/profile/ClipPlayerModal.jsx
import React from 'react';
import { useAuth } from '../../hooks/useAuth'; // 🟢 1. Importamos el hook de auth
import { useProfileStore } from '../../stores/useDataStore'; // 🟢 2. Importamos el store de perfil

const ClipPlayerModal = ({ isOpen, onClose, clip, modalData }) => {
  const resolvedClip = clip || modalData?.clip;
  if (!isOpen || !resolvedClip) return null;

  const { currentUser } = useAuth();
  const likeClip = useProfileStore((state) => state.likeClip); // 🟢 3. Obtenemos la acción del store
  const isLiked = resolvedClip.likes?.includes(currentUser?._id);

  return (
    <div
      className="fixed inset-0 bg-black bg-opacity-80 flex justify-center items-center z-50"
      onClick={onClose}
    >
      <div
        className="relative bg-white rounded-lg shadow-xl w-full max-w-2xl overflow-hidden"
        onClick={(e) => e.stopPropagation()}
      >
        <video
          src={resolvedClip.url}
          className="w-full h-auto max-h-[80vh] bg-black"
          controls
          autoPlay
        >
          Tu navegador no soporta la etiqueta de video.
        </video>
        {/* Pie de página para las acciones sociales */}
        <div className="p-4 border-t border-gray-200 flex justify-between items-center">
          <div className="flex space-x-6">
            <button
              onClick={() => likeClip(resolvedClip._id)}
              className="text-gray-600 hover:text-red-500 flex items-center space-x-1 transition-colors"
            >
              <i className={`${isLiked ? 'fas text-red-500' : 'far'} fa-heart text-xl`}></i>
              <span className="font-semibold">{resolvedClip.likes?.length || 0}</span>
            </button>
            <button className="text-gray-600 hover:text-blue-500 flex items-center space-x-1 transition-colors">
              <i className="far fa-comment text-xl"></i>
              <span className="font-semibold">
                {resolvedClip.comments?.length || 0}
              </span>
            </button>
            <button className="text-gray-600 hover:text-green-500 flex items-center space-x-1 transition-colors">
              <i className="fas fa-share-alt text-xl"></i>
            </button>
          </div>
          <button
            onClick={onClose}
            className="text-gray-400 hover:text-gray-700 transition-colors"
          >
            <i className="fas fa-times text-2xl"></i>
          </button>
        </div>
      </div>
    </div>
  );
};

export default ClipPlayerModal;
